<template>
  <div>
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <a-card
          :bordered="false"
          class="header-solid h-full"
          :bodyStyle="{ padding: 0 }"
        >
          <template #title>
            <a-row type="flex" align="middle">
              <a-col :span="24" :md="12">
                <h5 class="font-semibold m-0">جدول کاربران</h5>
              </a-col>
              <a-col
                :span="24"
                :md="12"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                "
              >
                <a-button
                  class="btn-outline-purple"
                  icon="search"
                  @click="isHidden = !isHidden"
                >
                  جستجو
                </a-button>
                &nbsp;

                <a-button v-show="$root.hasPermission('/users/add/')"
                  href="/users/add"
                  class="btn-outline-blue"
                  icon="plus"
                >
                  افزودن کاربر
                </a-button>
                &nbsp;
             <ExportUser />
              </a-col>
            </a-row>
          </template>

          <b-card
            style="margin:20px; !important ; border:none;"
            v-if="isHidden"
          >
              <a-col :md="4">
                <label class="sr-only" for="inline-form-input-name"
                  >نوع کاربر</label
                >
                <select class="form-control" v-model="search.type">
                  <option value="">انتخاب</option>
                  <option value="admin">ادمین</option>
                  <option value="legal">حقوقی</option>
                  <option value="real">حقیقی</option>
                </select>
              </a-col>
              <a-col :md="4">
                <label class="sr-only" for="inline-form-input-name">
                  موبایل</label
                >
                <b-form-input
                  v-model="search.phone"
                  id="inline-form-input-name"
                  class="mb-2 mr-sm-2 mb-sm-0"
                ></b-form-input>
              </a-col>
              <a-col :md="4">
                <label class="sr-only" for="inline-form-input-name"
                  >ایمیل</label
                >
                <b-form-input
                  v-model="search.email"
                  id="inline-form-input-name"
                  class="mb-2 mr-sm-2 mb-sm-0"
                ></b-form-input>
              </a-col>
              <a-col :md="4">
                <label class="sr-only" for="inline-form-input-name"
                  >نام خانوادگی</label
                >
                <b-form-input
                  v-model="search.lastname"
                  id="inline-form-input-name"
                  class="mb-2 mr-sm-2 mb-sm-0"
                ></b-form-input>
              </a-col>
              <a-col :md="4">
                <label class="sr-only" for="inline-form-input-name">نام</label>
                <b-form-input
                  v-model="search.firstname"
                  id="inline-form-input-name"
                  class="mb-2 mr-sm-2 mb-sm-0"
                ></b-form-input>
              </a-col>
              <a-col :md="4">
                <label class="sr-only" for="inline-form-input-name"
                  >کد ملی
                </label>
                <b-form-input
                  v-model="search.national_code"
                  id="inline-form-input-name"
                  class="mb-2 mr-sm-2 mb-sm-0"
                ></b-form-input>
              </a-col>
              <a-col style="margin-top: 20px" :md="4">
                <a-button
                  class="btn-outline-green w-100"
                  icon="search"
                  @click="getData"
                >
                  جستجو
                </a-button>
                
              </a-col>
          </b-card>
          <a-row
            style="justify-content: center; display: flex"
            v-if="$store.state.loading"
          >
            <template>
              <div>
                <a-spin />
              </div>
            </template>
          </a-row>
          <div v-else>
            <section class="w-100 p-4 text-center">
            <div class="table-responsive">
              <table class="table table-hover ">
                <thead>
                  <tr>
                    <th scope="col">شناسه</th>
                    <th scope="col">کاربر</th>
                    <th scope="col">نوع کاربری</th>
                    <th scope="col">موجودی کیف پول</th>
                    <th scope="col">موجودی تهاتری</th>
                    <th scope="col">سرمایه اولیه</th>
                     <th scope="col">فعال کردن کاربر</th>


                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in data">
                    <th scope="row">#{{ row.id }}</th>
                    <td>
                      <b-avatar
                        size="1.5rem"
                        :src="$root.image_concat(row.image)"
                      ></b-avatar>

                      <b-badge variant="light" class="text-dark">{{
                        $root.full_name( row.firstname , row.lastname)
                      }}</b-badge>
                    </td>
                    <td>
                      <b-badge
                        v-if="row.type == 'admin'"
                        variant="light"
                        class="bg-secondary"
                        >ادمین</b-badge
                      >
                      <b-badge
                        v-else-if="row.type == 'legal'"
                        variant="light"
                        class="bg-secondary"
                        >حقوقی</b-badge
                      >
                      <b-badge v-else variant="light" class="bg-secondary"
                        >حقیقی</b-badge
                      >
                    </td>

                    <td>
                      <b-badge pill variant="info" class="bg-success"
                        >{{ $root.number_format(row.wallet) }}
                      </b-badge>
                    </td>
                    <td>
                      <b-badge pill variant="info" class="bg-info">{{
                        $root.number_format(row.barter)
                      }}</b-badge>
                    </td>
                    <td>
                      <b-badge pill variant="info" class="bg-primary">{{
                        $root.number_format(row.investment)
                      }}</b-badge>
                    </td>
                     <td>
                                            <a-switch v-model="row.status" @change="changeStatus(row.id)" :disabled="!$root.hasPermission('/products/status/')" />
                                        </td>
                    <td>
                      <a-button v-show="$root.hasPermission('/users/detail/')"
                        class="btn-outline-primary"
                        shape="square"
                        :href="'/users/detail/'+row.id"

                      >اطلاعات مالی</a-button>
                      &nbsp;
                      <a-button v-show="$root.hasPermission('/users/show/') || $root.hasPermission('/users/edit/')"
                        class="btn-outline-info"
                        shape="square"
                        icon="eye"
                        :href="'/users/show/'+row.id"

                      />
                      &nbsp;
                      <a-button v-show="$root.hasPermission('/users/edit/')"
                        class="btn-outline-warning"
                        shape="square"
                        icon="edit" 
                        :href="'/users/edit/'+row.id"

                      />
                      &nbsp;
                      <!-- <a-button
                        class="btn-outline-danger" v-show="$root.hasPermission('/users/delete/')"
                        shape="square"
                        icon="delete"
                        @click="deleteRow(`users/delete/${row.id}`)"
                      ></a-button> -->
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
            </section>
            <a-row class="pagination">
              <a-pagination
                :total="total"
                :item-render="$root.itemRender"
                @change="getData(currentPage)"
                v-model="currentPage"
              />
            </a-row>
          </div>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
    import ExportUser from "../../components/Blocks/ExportUser.vue"

export default {
  components:{
    ExportUser
  },
  data() {
    return {
      data: [],
      currentPage: 1,
      total: 0,
      isHidden: false,
      search: {
        firstname: "",
        lastname: "",
        type: "",
        phone: "",
        email: "",
        national_code: "",
      },
    };
  },
  methods: {
    async getData() {
      let _this = this;
      this.$store.state.loading = true;
      let url = `/users?page=${this.currentPage}&&firstname=${this.search.firstname}&&lastname=${this.search.lastname}&&type=${this.search.type}&&phone=${this.search.phone}&&email=${this.search.email}&&national_code=${this.search.national_code}`;
      await axios
        .get(url)
        .then(function (response) {
          _this.data = response.data.data;
          _this.$store.state.loading = false;
          _this.total = response.data.total;
          _this.currentPage = response.data.current_page;
        })
        .catch(function (err) {
          _this.$root.handleAxiosError(err);
        });
    },
    clear() {
      this.search = {
        firstname: "",
        lastname: "",
        type: "",
        phone: "",
        email: "",
        national_code: "",
      };
      this.getData();
    },
    deleteRow(url) {
      this.$swal({
        title: "آیا از حذف اطلاعات اطمینان دارید؟",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "بله",
        denyButtonText: "لغو",
      }).then((result) => {
        if (result.isConfirmed) {
          let _this = this;
          axios
            .get(url)
            .then(function (response) {
              _this.$toast.success("با موفقیت حذف شد.");
              _this.getData();
            })
            .catch(function (err) {
              _this.$root.handleAxiosError(err);
            });
        }
      });
    },
    async changeStatus(id){
              let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/users/status/${id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.getData();
                        _this.$toast.success("کاربر مورد نظر با موفقیت ویرایش شد.");

                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scope>
.pagination {
  display: flex;
  justify-content: center;
  margin: 15px;
}
</style>
